import { Injectable } from "@angular/core";
import { SignatureApi } from "../api/signatures.api";
import { WrittenSignatureDTO } from "../model/written-signature-dto.model";

@Injectable()
export class SignatureService {

    constructor(private signatureApi: SignatureApi) { }

    getSignature = () =>
        this.signatureApi.getSignature();

    getSignatureForUserId = (userId: string) =>
        this.signatureApi.getSignatureForUserId(userId);

    saveSignature = (sig: WrittenSignatureDTO) =>
        this.signatureApi.saveSignature(sig);

}
